// extracted by mini-css-extract-plugin
export default {"sumTable":"sumTable_sumTable__0W7sZ","sumTable__listItem":"sumTable_sumTable__listItem__3G0tj","sumTable__listSeparator":"sumTable_sumTable__listSeparator__Lisgc"};